import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppstateService {

  isAppSideBar = new BehaviorSubject<boolean>(false);

  constructor() { }
}
